import React from 'react';

import { BannerWrapper } from '@/modules/CarsStock/components/common.styles';
import { useTypedSelector } from '@/store/store';
import { selectStockCarsBanner } from '@/store/reducers/banners';
import { getPage, getSelectedFilters } from '@/store/reducers/cars-stock';
import CarsStockBanner from '@/components/CarsStockBanner';

import { BannerProps } from './types';

function Banner({ position }: BannerProps) {
  const banner = useTypedSelector(selectStockCarsBanner);
  const page = useTypedSelector(getPage);
  const { selectedCars } = useTypedSelector(getSelectedFilters);
  const bannerPosition = banner.mobile?.position
    ? banner.mobile?.position - 1
    : 0;

  if (
    !banner ||
    !banner.mobile ||
    page.currentPage !== 1 ||
    selectedCars.selectedBrands.length > 1 ||
    selectedCars.selectedModels.length > 1 ||
    bannerPosition !== position
  ) {
    return null;
  }

  return (
    <BannerWrapper>
      <CarsStockBanner
        image={{ tablet: { url: banner.mobile.image ?? '' } }}
        url={banner.mobile.url}
        isNewTab={banner.mobile.isNewTab}
      />
    </BannerWrapper>
  );
}

export default Banner;
